<template>
  <div>
    <h1>Vat actions</h1>
    <v-btn :to="{ name: 'vatCreate' }"> <v-icon>add</v-icon>Vat create </v-btn>
    <v-btn
      v-if="$keycloak.hasRealmRole('root')"
      :to="{ name: 'vatCreate', query: { test: true } }"
    >
      <v-icon>add</v-icon>Vat create (test)
    </v-btn>
    <v-btn v-if="$keycloak.hasRealmRole('root')" :to="{ name: 'vatTest' }">
      <v-icon>add</v-icon>Vat test
    </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="vats"
      :loading="$apollo.queries.vats.loading"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{ name: 'vatAction', params: { id: props.item.id } }">{{
              props.item.id
            }}</v-btn>
          </td>
          <td>{{ props.item.vrn }}</td>
          <td>{{ props.item.action }}</td>
          <td>{{ processResponse(props.item.response) }}</td>
          <td>
            <EntityZ
              v-if="props.item.user"
              :entity="props.item.user"
              format="system"
            />
          </td>
          <td>{{ props.item.timestamp | formatDateTime }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import VATS from "@/graphql/accounts/vat/Vats";
export default {
  name: "VatActions",
  metaInfo() {
    return {
      title: "Vat actions",
      titleTemplate: "%s - Accounts - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ
  },
  apollo: {
    vats: {
      query: VATS,
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      headers: [
        {
          text: "id",
          value: "id"
        },
        {
          text: "vrn",
          value: "vrn"
        },
        {
          text: "action",
          value: "action"
        },
        {
          text: "response",
          value: "response"
        },
        {
          text: "user",
          sortable: false
        },
        {
          text: "timestamp",
          value: "timestamp"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "timestamp",
        descending: true
      }
    };
  },
  methods: {
    processResponse(response) {
      if (!response) {
        return "No response";
      }
      if (response.code && response.message) {
        return "Error";
      }
      if (response.statusCode && response.message) {
        return "Error with status";
      }
      return "Healthy response";
    }
  }
};
</script>